/** @module Apparel/MSGNewMaterialController */
define([
    "dojo/_base/declare",
    "csi/table/New",
    "csi/xml"
], function(declare,New,xml) {

    return declare(New, {
        /**
         * @override
         * Add material to material security group.
         */
        toWriter: function() {
            this.inherited(arguments);
            this.m_writer.changeNode(this.m_urlNode).changeAttribute("MaterialSecurityGroups", xml.ATTR_REFSET, [this.m_urlParent]);
        }
    });
});